import { put, call, take, fork } from 'redux-saga/effects'
import { aiInstructionRequestService } from '../../api/course'
import { AI_INSTRUCTION } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* aiInstructionFlow(payload) {
  try {
    const { starterText, language, callback } = payload

    const response = yield call(
      aiInstructionRequestService,
      starterText,
      language,
    )

    yield put(operationSuccess())

    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* aiInstructionWatcher() {
  while (true) {
    const action = yield take(AI_INSTRUCTION)
    const { payload } = action

    yield fork(generalSaga, aiInstructionFlow, payload, false)
  }
}
